import * as MainLayout from './Main'
import * as BaseLayout from './Base'
import * as TitleAndContentsLayout from './TitleAndContents'

export const Main = MainLayout.Component
export const Base = BaseLayout.Component
export const TitleAndContents = TitleAndContentsLayout.Component
